import React from 'react';
import PropTypes from 'prop-types';
import { Heading, Surface } from '@americanexpress/dls-react';
import Step from './Step';
import Progress from './Progress';
import styles from './Steps.scss';
import sharedStyles from '../../styles/shared.scss';
import { useDataFromOneCMS } from '../../fetchye/useDataFromOneCMS';

const StepsComponent = ({ isOverlay }) => {
  const heading = useDataFromOneCMS('howToSection.heading');
  const step1 = useDataFromOneCMS('howToSection.step1');
  const step2 = useDataFromOneCMS('howToSection.step2');

  return (
    <Surface variant={isOverlay ? 'fg-brand' : 'foreground'} className="flex flex-justify-center dls-white-bg">
      <div
        className={`${styles.stepsContainer} pad-2 pad-0-tb-sm-down flex flex-column flex-align-items-center`}
        id="TravelCreditSteps"
      >
        <div
          className={`text-align-center pad-1-b-sm-down ${isOverlay ? 'pad-1-b pad-2-t-sm-down' : 'pad-2-tb'}`}
        >
          <Heading level={2} variant="sans-large-book" className={sharedStyles.heading}>
            {' '}
            {heading}{' '}
          </Heading>
        </div>
        <Progress
          isOverlay={isOverlay}
          step1={step1.heading}
          step2={step2.heading}
        />
        <div className="flex flex-align-content-between pad-0-lr-sm-down row pad-3-tb">
          <div className="col-md-6">
            <Step number={1} details={step1} />
          </div>
          <div className="col-md-6">
            <Step number={2} details={step2} />
          </div>
        </div>
      </div>
    </Surface>
  );
};

StepsComponent.propTypes = {
  isOverlay: PropTypes.bool,
};

StepsComponent.defaultProps = {
  isOverlay: false,
};

export default StepsComponent;
